import useHasSellerSettingsPermissions from '../../../../hooks/Permissions/useHasSellerSettingsPermissions';
import useHasTenantPermission from '../../../../hooks/Permissions/useHasTenantPermission';

const useHasSellerSettingsPagePermission = () => {
  const tenantsPermissions = useHasTenantPermission();
  const sellersPermissions = useHasSellerSettingsPermissions();

  return [
    ...Object.values(tenantsPermissions),
    ...Object.values(sellersPermissions),
  ].includes(true);
};

export default useHasSellerSettingsPagePermission;
